<script setup lang="ts">
  import { Execution } from '@/shared/Executions/models/Execution'
  import { copyToClipboard } from '@/utils'

  const props = defineProps<{
    record: Execution
    index?: number
    selectable?: boolean
    onCellClick?: (record: Execution, e?: Event) => void
  }>()

  function handleClick(e?: Event) {
    if (props.selectable && props.onCellClick) {
      props.onCellClick(props.record, e)
    }
  }

  function handleCopy(e?: Event) {
    e?.stopPropagation()
    copyToClipboard(props.record?.id || '', "id")
  }
</script>

<template>
  <div :class="{ 'cursor-pointer': selectable }" @click="handleClick">
    <a-tooltip>
      <template #title>
        <div>
          <div><b>Id:</b> {{ record.id }}</div>
          <br />
          <div><b>Name:</b> {{ record.name }}</div>
        </div>
      </template>
      <div class="exec-name-text" @click="handleCopy">{{ record.name ?? 'Unknown' }}</div>
    </a-tooltip>
  </div>
</template>

<style scoped>
.exec-name-text {
  display: block;
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2; /* adjust as needed */
}
</style>